import { union } from 'underscore';
import { Panel as BootstrapPanel } from 'react-bootstrap';
import { BootstrapExpandableActuator, CustomExpandableActuator } from '@bingads-webui-campaign-react/actuator';
import { withContainerRenderingErrorHandling, withContainerPropInjectingErrorHandling } from '@bingads-webui-campaign-react/error-handling';
import { withFluentSwitcher } from '@bingads-webui-react/fluent-version-switcher';

import { Collapse } from './components/collapse/collapse';
import { Panel } from './components/collapse/panel';
import { FixedPanel } from './components/collapse/fixed-panel';
import { ValidatedPanel as ValidatedPanelV2, ValidatedFixedPanel as ValidatedFixedPanelV2 } from './components/panel-v2-shim';

Collapse.Panel = Panel;
Collapse.FixedPanel = FixedPanel;
export { Collapse };
export { ToggleTitle } from './components/common/toggle-title';
export { TextTitle } from './components/common/text-title';
export { TitleBarError } from './components/common/title-bar-error';

export * from './components/collapse/use-collapse-state';

export const collapseExpander = ({ setActiveKeys }) => (key) => {
  setActiveKeys(activeKeys => union(activeKeys, [key]));
};

export const getPanelErrorProps = ({ needsAttention }) => (needsAttention ? {
  error: _TL_("* Something's wrong"),
} : {});

export const ValidatedFixedPanelV1 = withContainerPropInjectingErrorHandling(Collapse.FixedPanel);
export const ValidatedPanelV1 = withContainerPropInjectingErrorHandling(Collapse.Panel, [CustomExpandableActuator]);
export const ValidatedBootstrapPanel = withContainerRenderingErrorHandling(BootstrapPanel, [BootstrapExpandableActuator]);

export const ValidatedPanel = withFluentSwitcher(ValidatedPanelV1, ValidatedPanelV2);
export const ValidatedFixedPanel = withFluentSwitcher(ValidatedFixedPanelV1, ValidatedFixedPanelV2);
